import { useState } from "react";
import { useScenario } from "@/context/ScenarioContext";
import { ListOrdered, X } from "lucide-react";

// Recordatorio discreto del guion de la demostración. Sólo en DEMO, sólo lectura, sin backend.
const PASOS = {
  demo_inst: [
    "Radar del Centro: 20 residentes, quién requiere atención y qué cobertura revisar.",
    "Abre la CAÍDA de Don Alberto (Hab. 103): plan de respuesta y contactos ya congelados.",
    "Toma el caso: lo atiende el personal del centro, no Galarya.",
    "Registra qué ocurrió al hablar con la persona (hecho factual, sin diagnóstico).",
    "Cierra con la nota de lo verificado; el desenlace queda documentado.",
    "Muestra Bitácora y la ficha del residente: misma secuencia, sin recapturar nada.",
  ],
  demo_resid: [
    "Central Galarya: cola por prioridad, actividad reciente e incidencias técnicas.",
    "Abre la CAÍDA de Doña Refugio: domicilio, zona y contactos autorizados.",
    "Toma el caso: aquí opera Central Galarya 24/7.",
    "Registra el resultado del audio y, si aplica, la llamada al contacto.",
    "Cierra con la nota factual del desenlace.",
    "Muestra Bitácora y el padrón de 30 personas atendidas.",
  ],
};

export default function DemoGuion() {
  const { scenario, isDemo } = useScenario();
  const [abierto, setAbierto] = useState(false);
  if (!isDemo) return null;
  const pasos = PASOS[scenario] || PASOS.demo_inst;
  return (
    <div className="pointer-events-none fixed bottom-4 left-4 z-40">
      {abierto ? (
        <div data-testid="demo-guion-panel" className="pointer-events-auto max-h-[60vh] w-[calc(100vw-2rem)] max-w-[330px] overflow-y-auto rounded-xl border border-[#9B2C2C]/30 bg-white/95 p-3 shadow-lg backdrop-blur dark:border-[#9B2C2C]/50 dark:bg-[#0F1729]/95">
          <div className="mb-2 flex items-center justify-between">
            <p className="text-[11px] font-extrabold uppercase tracking-wider text-[#9B2C2C] dark:text-[#F2B8B8]">Guion de la demostración</p>
            <button data-testid="demo-guion-cerrar" onClick={() => setAbierto(false)} aria-label="Ocultar guion"
              className="rounded p-0.5 text-slate-400 transition-colors hover:text-slate-700 dark:hover:text-slate-200">
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
          <ol data-testid="demo-guion-pasos" className="space-y-1.5">
            {pasos.map((p, i) => (
              <li key={i} className="flex gap-2 text-xs leading-snug text-slate-600 dark:text-slate-300">
                <span className="mt-[1px] flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-[#9B2C2C]/10 text-[10px] font-bold text-[#9B2C2C] dark:text-[#F2B8B8]">{i + 1}</span>
                {p}
              </li>
            ))}
          </ol>
        </div>
      ) : (
        <button data-testid="demo-guion-abrir" onClick={() => setAbierto(true)}
          title="Guion de la demostración (sólo visible en escenarios demo)"
          className="pointer-events-auto inline-flex max-w-[calc(100vw-2rem)] items-center gap-1.5 rounded-full border border-[#9B2C2C]/30 bg-white/90 px-3 py-1.5 text-[11px] font-bold text-[#9B2C2C] shadow-sm backdrop-blur transition-colors hover:bg-white dark:border-[#9B2C2C]/50 dark:bg-[#0F1729]/90 dark:text-[#F2B8B8]">
          <ListOrdered className="h-3.5 w-3.5 shrink-0" /> <span className="truncate">Guion de la demostración</span>
        </button>
      )}
    </div>
  );
}
